import { useEffect, useState } from "react"
import AgoraRegularManager from "../Agora/AgoraRegularManager"
import { AgoraManagerType } from "../Agora/AgoraManager"
import AgoraAudioManager from "../Agora/AgoraAudioManager"
import { IMicrophoneAudioTrack } from "agora-rtc-sdk-ng"

interface IAdditionalRegularDeviceProps
{
    manager: AgoraRegularManager
    onError: (error: unknown, deviceId?: string) => void,
    onStart?: (published: boolean, type: AgoraManagerType, sourceId: string) => void,
    onStopAdditionalDevHandler?: (type: AgoraManagerType, sourceId: string) => void,
    source: MediaDeviceInfo
}

const AdditionalRegularDevice = (props: IAdditionalRegularDeviceProps) => {
    const { manager: parentManager, source, onError } = props

    const [agoraManager, setAgoraManager] = useState<AgoraAudioManager>()
    const [startCommunication, setStartCommunication] = useState<boolean>(false)
    const [microphoneTrack, setMicrophoneTrack] = useState<IMicrophoneAudioTrack>()

    useEffect(() => {
        if(!parentManager?.client) return

        if(!agoraManager)
        {
            console.log("Add additional device")
    
            const am = new AgoraAudioManager(parentManager.client, onError)
            am.initialize({})
                .then((track: IMicrophoneAudioTrack) => {
                console.debug("Props", props)
                console.debug("Additional device audio manager initialized")

                setAgoraManager(am)
                setMicrophoneTrack(track)
                setStartCommunication(true)
            })
        }

        return () => {
            if(!(agoraManager && parentManager)) return
            if(props.onStopAdditionalDevHandler)
                props.onStopAdditionalDevHandler("audio", source.deviceId)

            try
            {
                agoraManager.destroy()
            }
            catch(error)
            {
                console.error("Could not remove device", agoraManager)
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [agoraManager, parentManager])

    useEffect(() => {
        if(!startCommunication) return
        if(!parentManager?.client) return
        if(!agoraManager?.tracks) return
        if(!microphoneTrack) return
        
        
        agoraManager.publish(true, source.deviceId)
    }, [parentManager, agoraManager, microphoneTrack, startCommunication])

    useEffect(() => {
        console.debug("Agora regular manager tracks changed", agoraManager?.tracks)
    }, [agoraManager?.tracks])
    
    useEffect(() => {
        if(!(source && typeof source === "object")) return;

        if(agoraManager?.tracks)
        {
            agoraManager.tracks.setDevice(source.deviceId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [source, agoraManager?.tracks])

    return (null)
}

export default AdditionalRegularDevice
